/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { OperatorDto, OperatorsListFilterParams } from '../api/operators/operatorsClient.typings';
import { OperatorsActions, OperatorsActionType } from '../actions/operatorsActions';
import { OperatorsListTableData } from '../../components/RegistryWidgets/Operators/OperatorsList/OperatorsListConfig';

export const defaultSearchType: keyof OperatorsListTableData = 'taxNumber';
const defaultPageLimit = 20;

export interface OperatorsState {
    operatorsList: OperatorDto[];
    limit: number;
    afterKey: string;
    isLoading: boolean;
    filterParams: OperatorsListFilterParams;
    changedFilterParams: OperatorsListFilterParams;
    lastRequestItemsCount: number;
}

const initialState: OperatorsState = {
    operatorsList: [],
    limit: defaultPageLimit,
    afterKey: null,
    lastRequestItemsCount: null,
    filterParams: {
        search_type: defaultSearchType,
        search_text: '',
        statuses: [],
    },
    changedFilterParams: null,
    isLoading: false,
};

function operatorsReducer(state: OperatorsState = initialState, action: OperatorsActions): OperatorsState {
    switch (action.type) {
        case OperatorsActionType.OPEN_REGISTRY_OPERATORS_LIST_PAGE:
            return {
                ...state,
            };

        case OperatorsActionType.APPLY_FILTER:
            return {
                ...state,
                operatorsList: [],
                isLoading: true,
                afterKey: null,
                lastRequestItemsCount: null,
                filterParams: state.changedFilterParams ? { ...state.changedFilterParams } : { ...state.filterParams },
                changedFilterParams: null,
            };

        case OperatorsActionType.FETCH_NEXT_PAGE_START:
            return {
                ...state,
                isLoading: true,
            };

        case OperatorsActionType.CHANGE_FILTERS:
            return {
                ...state,
                changedFilterParams: action.payload,
            };

        case OperatorsActionType.FETCH_OPERATORS_LIST_SUCCESS:
            const combinedList: OperatorDto[] = [...state.operatorsList];

            if (action.payload.list.operators && action.payload.list.operators.length > 0) {
                combinedList.push(...action.payload.list.operators);
            }

            return {
                ...state,
                isLoading: false,
                operatorsList: combinedList,
                afterKey: action.payload.list.afterKey,
                lastRequestItemsCount: action.payload.list.operators.length,
            };

        case OperatorsActionType.FETCH_OPERATORS_LIST_ERROR:
            return {
                ...state,
                isLoading: false,
                operatorsList: [],
            };

        case OperatorsActionType.DOWNLOAD_EXCEL:
            return {
                ...state,
                isLoading: true,
            };

        case OperatorsActionType.DOWNLOAD_EXCEL_SUCCESS:
        case OperatorsActionType.DOWNLOAD_EXCEL_ERROR:
            return {
                ...state,
                isLoading: false,
            };

        case OperatorsActionType.EXIT_REGISTRY_OPERATORS_LIST_PAGE:
            return {
                ...state,
            };

        default:
            return state;
    }
}

export default operatorsReducer;
